<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <PromotionPopup :data-set="dataSet" @close="close" @open="open" @open-agent-popup="openAgentPopup"
            @open-p-w-a-popup="openPWAPopup"  />
    </div>
    <div v-if="themeStore.themeIndex === 2">
        <PromotionPopupTwo :data-set="dataSet" @close="close" @open="open" @open-agent-popup="openAgentPopup"
            @open-p-w-a-popup="openPWAPopup"  />
    </div>
</template>


<script setup lang="ts">
import { ref, defineExpose, defineEmits, computed } from 'vue'
import { useActivityStore } from '@/stores/activity';
import PromotionPopup from '@/themes/themeOne/promotion/promotionPopup.vue';
import PromotionPopupTwo from '@/themes/themeTwo/promotion/promotionPopup.vue';
import { PromotionData } from './supporrtScript';
import { useThemeStore } from '@/stores/theme';

const themeStore = useThemeStore()
const activityStore = useActivityStore()

const show = ref(false)
const promotionList = computed<any>(() => activityStore.activityList)

const dataSet = computed<PromotionData>(() => ({
    show: show.value,
    promotionList: promotionList.value
}))

const emits = defineEmits(['handleClose', "openAgent", "openPWA"])
const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
    emits('handleClose')
}
const openAgentPopup = () => {
    emits("openAgent")
}

const openPWAPopup = () => {
    emits("openPWA")
}

defineExpose({
    open,
    close
})



</script>